export {default} from './AirbnbListingModel';
export * from './AirbnbListingModel';



// WEBPACK FOOTER //
// ./src/models/AirbnbListingModel/index.ts